import React from "react";
import PageHeader from "../common/HeaderPage";
import Card from "react-bootstrap/Card";
import CardGroup from "react-bootstrap/CardGroup";
export default function MTDPage() {
  return (
    <section
      id="content"
      className="container clearfix"
      style={{
        padding: "0px",
        outline: "none",
        margin: "0px auto",
        marginBottom: "0px"
      }}
    >
      <PageHeader title={"MTD - Making Tax Digital"}></PageHeader>

      <CardGroup>
        <Card>
          <Card.Img variant="top" />
          <Card.Body>
            <Card.Title>VAT Filling</Card.Title>
            <Card.Text>
              VAT registered businesses are required to keep digital records and
              submit their VAT returns using MTD-compatible software. This is
              part of the UK legislation. We aim to make this process as easy as
              possible for Businesses and their accountants. Our MTD-VAT filling
              software is designed to help businesses comply with these
              requirements efficiently and effectively.
            </Card.Text>
          </Card.Body>
          <Card.Footer>
            <small className="text-muted">Demo</small>
          </Card.Footer>
        </Card>
        <Card>
          <Card.Img variant="top" />
          <Card.Body>
            <Card.Title>Income Tax Self Assesment</Card.Title>
            <Card.Text>
              Landlords and sole traders will be affected will be affected by
              the implemented policy:
              <li>2026 qualyfying income more than £50,000</li>
              <li>2027 qualyfying income more than £30,000</li>
            </Card.Text>
          </Card.Body>
          <Card.Footer>
            <small className="text-muted">Demo is comming</small>
          </Card.Footer>
        </Card>
        <Card>
          <Card.Img variant="top" />
          <Card.Body>
            <Card.Title>Accountants</Card.Title>
            <Card.Text>
              Accountants as an agent will be able to make VAT and Income Tax
              Self Assesment for multiple accounts.
            </Card.Text>
          </Card.Body>
          <Card.Footer>
            <small className="text-muted">Contact us for demo</small>
          </Card.Footer>
        </Card>
      </CardGroup>
      <div style={{ margin: "0px", padding: "0px", outline: "none" }}>
        <p
          style={{
            margin: "0px",
            padding: "0px",
            outline: "none",
            marginBottom: "20px"
          }}
        >
          <br></br>
          <br></br>
          <h4>Common Features</h4>
          We value your security and privacy. Our cloud based MTD software is
          designed with security in mind, ensuring that your data is protected
          at all times.
          <ul>
            <li>Our software has enhanced security.</li>
            <li>Enjoy enterprise security level.</li>
            <li>You are in control of your fillings and data</li>
          </ul>
        </p>
      </div>

      <p>
        <h4>Pricing</h4>
      </p>
      <CardGroup>
        <Card>
          <Card.Img variant="top" />
          <Card.Body>
            <Card.Title>VAT Filling</Card.Title>
            <Card.Text>Single license for a year.</Card.Text>
          </Card.Body>
          <Card.Footer>
            <small className="text-muted">
              <li>
                <small className="text-muted">Free</small>
              </li>
              <li>
                <small className="text-muted">Create account</small>
              </li>
            </small>
          </Card.Footer>
        </Card>
        <Card>
          <Card.Img variant="top" />
          <Card.Body>
            <Card.Title>Income Tax Self Assesment</Card.Title>
            <Card.Text>Single license for a year.</Card.Text>
          </Card.Body>
          <Card.Footer>
            <small className="text-muted">
              <li>
                <small className="text-muted">Free</small>
              </li>
              <li>
                <small className="text-muted">Create account</small>
              </li>
            </small>
          </Card.Footer>
        </Card>
        <Card>
          <Card.Img variant="top" />
          <Card.Body>
            <Card.Title>Accountants</Card.Title>
            <Card.Text> Single license for a year.</Card.Text>
          </Card.Body>
          <Card.Footer>
            <li>
              <small className="text-muted">Free 10 licences</small>
            </li>
            <li>
              <small className="text-muted">Create account</small>
            </li>
          </Card.Footer>
        </Card>
      </CardGroup>
    </section>
  );
}
